import type { PinpointMappingType } from '../models/pinpoint';

export const generateDataPinpointAttributes = (
  pinpoint: PinpointMappingType,
) => {
  return `${pinpoint.field}-${JSON.stringify(pinpoint.path)}`;
};
